import React from 'react';
import IconSpinner from 'react-icons/lib/fa/spinner';

const Spinner = () =>  {
  return (
      <h2 className="loading">
          <IconSpinner className="spinner"/>
          <span>Loading...</span>
      </h2>
  )
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js